/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgAccountSummary = {
  header: 'Parados los resúmenes de cuentas ({{count}})',
  name: 'Unidad',
  details: {
    header: 'Detalles del resumen de la cuenta',
    uid: 'Unidad ID',
    name: 'Cliente',
    address: 'Dirección',
    creditRep: 'Representante de Crédito',
    creditLine: 'Línea de crédito',
    currentBalance: 'Saldo actual',
    openBalance: 'Saldo abierto',
    pastDueBalance: 'Saldo vencido',
    dayRange: '{{minBoundary}}-{{maxBoundary}} Días',
    dayPlus: '{{minBoundary}}+ Days',
    notApplicable: 'n/a',
  },
  document: {
    header: 'Documentos',
    id: 'Número de documento',
    type: 'Tipo de documento',
    date: 'Creado el',
    dueDate: 'Vencimiento el',
    originalAmount: 'Monto original',
    openAmount: 'Cantidad abierta',
    status: 'Estado',
    attachment: 'Archivo adjunto',
    download: 'Descargar',
    attachmentDescription: 'Descargar archivo adjunto para {{type}} {{{id}}.',
    noneFound: 'No se han encontrado documentos',
  },
  sorts: {
    byCreatedAtDateAsc: 'Creado el Ascending',
    byCreatedAtDateDesc: 'Creado el Descending',
    byDueAtDateAsc: 'Vencimiento el Ascending',
    byDueAtDateDesc: 'Vencimiento el Descending',
    byOriginalAmountAsc: 'Monto original Ascending',
    byOriginalAmountDesc: 'Monto original Descending',
    byAbrirAmountAsc: 'Cantidad abierta Ascending',
    byAbrirAmountDesc: 'Cantidad abierta Descending',
    byOrgDocumentTypeAsc: 'Tipo de documento Ascending',
    byOrgDocumentTypeDesc: 'Tipo de documento Descending',
    byEstadoAsc: 'Estado Ascendente',
    byEstadoDesc: 'Estado Descendente',
    byOrgDocumentIdAsc: 'Número de documento Ascending',
    byOrgDocumentIdDesc: 'Número de documento Descending',
  },
  statuses: {
    open: 'Abrir',
    closed: 'Cerrado',
    all: 'Parado',
  },
  filterByOptions: {
    orgDocumentId: 'Número de documento',
    orgDocumentIdRange: 'Número de documento Range',
    orgDocumentType: 'Tipo de documento',
    createdAtDateRange: 'Creado el Range',
    dueAtDateRange: 'Vencimiento el Range',
    amountRange: 'Gama Monto original',
    openAmountRange: 'Cantidad abierta Range',
  },
  sortBy: 'Ordenar por',
  sortDocumentos: 'Ordenar documentos',
  filter: {
    status: 'Estado',
    filterBy: 'Filtrar por',
    documentNumber: 'Número de documento',
    documentType: 'Tipo de documento',
    startRange: 'De',
    endRange: 'Para',
    clear: 'Clear Parado',
    search: 'Buscar',
    errors: {
      toDateMustComeAfterDe:
        "Elige una fecha de finalización posterior a la fecha de inicio.",
      toAmountMustBeLargeThanDe:
        "Elija un valor de intervalo final que sea menor que el valor inicial.",
    },
  },
  hint: 'Los resúmenes de cuentas le permiten revisar la información general sobre una unidad, incluidos los saldos y el resumen de antigüedad de las facturas. Aquí, también puede navegar a través de una lista de documentos de transacción para una unidad.',
};

export const orgAccountSummaryList = {
  breadcrumbs: {
    list: 'Resúmenes de cuentas',
    details: '{{name}}',
  },
};

export const accountSummary = {
  orgAccountSummary,
  orgAccountSummaryList,
};
